import * as React from 'react';
import useEvent from 'rc-util/lib/hooks/useEvent';
import showWaveEffect from './WaveEffect';
import { ConfigContext } from '../../config-provider';
import useToken from '../../theme/useToken';
export default function useWave(nodeRef, className, component) {
    const { wave } = React.useContext(ConfigContext);
    const [, token] = useToken();
    const showWave = useEvent((event) => {
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) {
            return;
        }
        const { showEffect } = wave || {};
        // Customize wave effect
        (showEffect || showWaveEffect)(node, { className, token, component, event });
    });
    return showWave;
}
